import Navbar from "../Navbar";
import Hero from "../Hero";
import Footer from "../Footer";

function Gallery(){
    return(
        <>
        <Navbar />
        <Hero
        cName="hero-mid"
        heroImg="/assert/homeBanner.jpg"
        title="Gallery"
        btnClass="hide"
        />

        <Footer />
        </>
    );
}

export default Gallery;